export default __webpack_public_path__ + "img/eUntzhug.f31ff260.svg";